import { DataCardinalities, DataVariants } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { EMPTY_VALUE, FieldSchema, FieldValueArray } from "../../../Schema";
import { Sop } from "../external-sources/Sops";
import { EquipmentContext } from "../../equipment";
import { KeyValueConstruct } from "../../common";

export const createSop = (context: EquipmentContext): FieldSchema => ({
  name: "sop",
  grid: {
    displayed: true,
    order: 18,
    // A cell holds a list of SOPs, so there is no single value to order rows by — whatever the
    // search index sorts on is an artefact of how the array is stored, not something a user asked
    // for. `tags` is declared the same way for the same reason.
    sortable: false,
  },
  graphql: { selection: "sop { key value }" },
  dataTransform: {
    fromGraphql: {
      getter: ({ sop }): FieldValueArray | typeof EMPTY_VALUE => {
        if (Array.isArray(sop)) {
          return (sop as KeyValueConstruct[]).map((item) => item.key);
        }
        return EMPTY_VALUE;
      },
    },
    toGraphql: {
      getter: ({ sop }) => {
        if (sop && Array.isArray(sop) && (sop as FieldValueArray).length) {
          return (sop as FieldValueArray).map((item) => ({ key: item, value: item }));
        }
        return EMPTY_VALUE;
      },
    },
    // The record stores the same key/value pairs GraphQL takes, not the bare keys the
    // field works in. Without this a write replaces [{key, value}] with ["key"], which
    // fromGraphql then reads back as nothing.
    toDb: {
      getter: ({ sop }) => {
        if (sop && Array.isArray(sop) && (sop as FieldValueArray).length) {
          return (sop as FieldValueArray).map((item) => ({ key: item, value: item }));
        }
        return EMPTY_VALUE;
      },
    },
  },
  data: {
    variant: DataVariants.ENUM,
    options: context.sops.map((sop: Sop) => ({ value: sop.key, label: sop.value })),
    cardinality: DataCardinalities.MULTIPLE,
  },
  display: {
    displayed: true,
  },
  form: { label: "SOP", type: InputTypes.MULTISELECT },
});
